<template>
  <div id="trend" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
export default {
  name: 'scholarTrend',
  props: ['data'],
  data() {
    return {
      trend: null,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getOption();
    });
  },
  methods: {
    getOption() {
      this.trend = this.$echarts.init(document.getElementById('trend'));
      let that = this;
      let option = {
        animation: false,
        tooltip: {
          trigger: 'axis',
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.data.years,
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: {
              color: '#fff',
            },
          },
        },
        legend: {
          data: this.data.legend,
          x: 'center',
          textStyle: {
            color: '#333',
            fontSize: 12,
          },
        },
        dataZoom: [
          {
            show: true,
            realtime: true,
            startValue: 2013,
            endValue: 2019,
          },
        ],
        series: (function () {
          let result = [];
          that.data.legend.forEach((v) => {
            let data = [];
            if (that.data.data[v])
              that.data.data[v].forEach((item) => {
                data.push(item.yearCount);
              });

            result.push({
              name: v,
              data: data,
              type: 'line',
            });
          });
          return result;
        })(),
      };

      this.trend.setOption(option);
      window.addEventListener('resize', () => {
        this.trend.resize();
      })
    },
  },
  watch: {
    data: {
      handler() {
        this.getOption();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
